
import React, { useState, useEffect } from 'react';
import './SalseClients.css';

const ClientsVendors = () => {
  // Initial clients data
  const [clients, setClients] = useState([
    {
      id: 1,
      clientNo: 'CLT-001',
      company: 'Acme Industries',
      contactPerson: 'Rohit Sharma',
      email: 'rohit@acme.in',
      phone: '+91 98200 11122',
      linkedEnquiry: 'ENQ-X1Y2Z',
      pos: 1,
      owner: 'Priya (Exec)',
      onboarded: '2025-04-20',
      status: 'Active',
      source: 'Quotation Accepted',
      fromDate: '2025-04-20',
      toDate: '2026-04-19',
      website: 'https://www.acmeindustries.com',
      agreementDoc: 'agreement_acme.pdf',
      lastRenewalDate: null,
      nextRenewalDate: '2026-04-19',
      poGenerated: false,
      lastPONumber: null,
      renewalSentCount: 0
    },
    {
      id: 2,
      clientNo: 'CLT-002',
      company: 'Nimbus Tech',
      contactPerson: 'Anita Desai',
      email: 'anita@nimbus.io',
      phone: '+91 98300 22333',
      linkedEnquiry: 'ENQ-P9Q3R',
      pos: 2,
      owner: 'Karan (Exec)',
      onboarded: '2025-04-18',
      status: 'Active',
      source: 'Quotation Accepted',
      fromDate: '2025-04-18',
      toDate: '2026-04-17',
      website: 'https://www.nimbustech.io',
      agreementDoc: 'agreement_nimbus.pdf',
      lastRenewalDate: null,
      nextRenewalDate: '2026-04-17',
      poGenerated: false,
      lastPONumber: null,
      renewalSentCount: 0
    },
    {
      id: 3,
      clientNo: 'CLT-003',
      company: 'Orbit Logistics',
      contactPerson: 'Vikram Mehta',
      email: 'vikram@orbit.co',
      phone: '+91 98400 33444',
      linkedEnquiry: 'ENQ-R7S8T',
      pos: 3,
      owner: 'Priya (Exec)',
      onboarded: '2025-04-15',
      status: 'Active',
      source: 'Manual Add',
      fromDate: '2025-04-15',
      toDate: '2026-04-14',
      website: 'https://www.orbitlogistics.co',
      agreementDoc: 'agreement_orbit.pdf',
      lastRenewalDate: null,
      nextRenewalDate: '2026-04-14',
      poGenerated: false,
      lastPONumber: null,
      renewalSentCount: 0
    },
    {
      id: 4,
      clientNo: 'CLT-004',
      company: 'BluePeak Foods',
      contactPerson: 'Sara Khan',
      email: 'sara@bluepeak.in',
      phone: '+91 98500 44555',
      linkedEnquiry: 'ENQ-U5V6W',
      pos: 4,
      owner: 'Karan (Exec)',
      onboarded: '2025-04-10',
      status: 'Active',
      source: 'Quotation Accepted',
      fromDate: '2025-04-10',
      toDate: '2026-04-09',
      website: 'https://www.bluepeak.in',
      agreementDoc: 'agreement_bluepeak.pdf',
      lastRenewalDate: null,
      nextRenewalDate: '2026-04-09',
      poGenerated: false,
      lastPONumber: null,
      renewalSentCount: 0
    }
  ]);

  // Listen for storage events to sync data from SalesQuotation
  useEffect(() => {
    const savedClients = localStorage.getItem('clientsData');
    if (savedClients) {
      const parsedClients = JSON.parse(savedClients);
      if (parsedClients.length > 0) {
        setClients(parsedClients);
      }
    }

    const handleNewClient = (event) => {
      if (event.data && event.data.type === 'NEW_CLIENT_GENERATED') {
        const newClientData = event.data.client;
        const exists = clients.some(c => c.clientNo === newClientData.id);
        if (!exists) {
          const newClient = {
            id: clients.length + 1,
            clientNo: newClientData.id,
            company: newClientData.name,
            contactPerson: newClientData.name,
            email: newClientData.email,
            phone: newClientData.phone,
            linkedEnquiry: newClientData.enquiryNo,
            pos: clients.length + 1,
            owner: newClientData.generatedBy,
            onboarded: newClientData.generatedDate,
            status: 'Active',
            source: 'Auto Generated',
            fromDate: newClientData.generatedDate,
            toDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
            website: '',
            agreementDoc: '',
            lastRenewalDate: null,
            nextRenewalDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
            poGenerated: false,
            lastPONumber: null,
            renewalSentCount: 0
          };
          
          setClients(prev => {
            const updated = [...prev, newClient];
            localStorage.setItem('clientsData', JSON.stringify(updated));
            return updated;
          });
          
          alert(`✅ New client "${newClient.company}" auto-added from quotation!`);
        }
      }
    };

    window.addEventListener('message', handleNewClient);
    
    const pendingClient = localStorage.getItem('pendingClientData');
    if (pendingClient) {
      const newClientData = JSON.parse(pendingClient);
      const exists = clients.some(c => c.clientNo === newClientData.id);
      if (!exists) {
        const newClient = {
          id: clients.length + 1,
          clientNo: newClientData.id,
          company: newClientData.name,
          contactPerson: newClientData.name,
          email: newClientData.email,
          phone: newClientData.phone,
          linkedEnquiry: newClientData.enquiryNo,
          pos: clients.length + 1,
          owner: newClientData.generatedBy,
          onboarded: newClientData.generatedDate,
          status: 'Active',
          source: 'Auto Generated',
          fromDate: newClientData.generatedDate,
          toDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
          website: '',
          agreementDoc: '',
          lastRenewalDate: null,
          nextRenewalDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
          poGenerated: false,
          lastPONumber: null,
          renewalSentCount: 0
        };
        
        setClients(prev => {
          const updated = [...prev, newClient];
          localStorage.setItem('clientsData', JSON.stringify(updated));
          return updated;
        });
        
        localStorage.removeItem('pendingClientData');
        alert(`✅ New client "${newClient.company}" auto-added from quotation!`);
      }
    }

    return () => window.removeEventListener('message', handleNewClient);
  }, []);

  // Modal states
  const [isAddClientModalOpen, setIsAddClientModalOpen] = useState(false);
  const [isViewClientModalOpen, setIsViewClientModalOpen] = useState(false);
  const [isRenewalModalOpen, setIsRenewalModalOpen] = useState(false);
  const [isGeneratePOModalOpen, setIsGeneratePOModalOpen] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [poSuccess, setPoSuccess] = useState({});
  const [renewalSuccess, setRenewalSuccess] = useState({});
  const [renewalForm, setRenewalForm] = useState({
    renewalPeriod: 12,
    newAmount: '',
    notes: ''
  });
  const [poForm, setPoForm] = useState({
    poNumber: '',
    poDate: new Date().toISOString().split('T')[0],
    amount: '',
    items: '',
    deliveryDate: '',
    notes: ''
  });

  // Form state for new client
  const [formData, setFormData] = useState({
    company: '',
    contactPerson: '',
    email: '',
    phone: '',
    linkedEnquiry: '',
    owner: 'Aarav (Admin)',
    fromDate: new Date().toISOString().split('T')[0],
    toDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
    website: '',
    agreementDoc: null
  });

  const ownerOptions = ['Aarav (Admin)', 'Priya (Exec)', 'Karan (Exec)', 'Neha (Manager)', 'Raj (Sales)'];

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'agreementDoc') {
      setFormData(prev => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleAddClient = () => {
    if (!formData.company || !formData.contactPerson || !formData.email || !formData.phone) {
      alert('Please fill all required fields: Company, Contact Person, Email, and Phone');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      alert('Please enter a valid email address');
      return;
    }

    if (formData.phone.length < 10) {
      alert('Please enter a valid phone number');
      return;
    }

    const newId = clients.length + 1;
    const newClientNo = `CLT-${String(newId).padStart(3, '0')}`;
    const today = new Date().toISOString().split('T')[0];

    const newClient = {
      id: newId,
      clientNo: newClientNo,
      company: formData.company,
      contactPerson: formData.contactPerson,
      email: formData.email,
      phone: formData.phone,
      linkedEnquiry: formData.linkedEnquiry || '—',
      pos: clients.length + 1,
      owner: formData.owner,
      onboarded: today,
      status: 'Active',
      source: 'Manual Add',
      fromDate: formData.fromDate,
      toDate: formData.toDate,
      website: formData.website,
      agreementDoc: formData.agreementDoc ? formData.agreementDoc.name : '',
      lastRenewalDate: null,
      nextRenewalDate: formData.toDate,
      poGenerated: false,
      lastPONumber: null,
      renewalSentCount: 0
    };

    const updatedClients = [...clients, newClient];
    setClients(updatedClients);
    localStorage.setItem('clientsData', JSON.stringify(updatedClients));

    setFormData({
      company: '',
      contactPerson: '',
      email: '',
      phone: '',
      linkedEnquiry: '',
      owner: 'Aarav (Admin)',
      fromDate: new Date().toISOString().split('T')[0],
      toDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
      website: '',
      agreementDoc: null
    });

    setIsAddClientModalOpen(false);
    alert(`Client "${newClient.company}" added successfully!`);
  };

  const viewClientDetails = (client) => {
    setSelectedClient(client);
    setIsViewClientModalOpen(true);
  };

  const handleRenewal = (client) => {
    setSelectedClient(client);
    setRenewalForm({
      renewalPeriod: 12,
      newAmount: '',
      notes: ''
    });
    setIsRenewalModalOpen(true);
  };

  const submitRenewal = () => {
    const today = new Date().toISOString().split('T')[0];
    const newToDate = new Date();
    newToDate.setMonth(newToDate.getMonth() + renewalForm.renewalPeriod);
    const newToDateStr = newToDate.toISOString().split('T')[0];

    // Update client with new renewal dates
    const updatedClients = clients.map(c => {
      if (c.id === selectedClient.id) {
        return {
          ...c,
          fromDate: today,
          toDate: newToDateStr,
          lastRenewalDate: today,
          nextRenewalDate: newToDateStr,
          status: 'Active',
          renewalSentCount: (c.renewalSentCount || 0) + 1
        };
      }
      return c;
    });

    setClients(updatedClients);
    localStorage.setItem('clientsData', JSON.stringify(updatedClients));

    // Show success tick mark on the renewal button
    setRenewalSuccess({ [selectedClient.id]: true });
    setTimeout(() => {
      setRenewalSuccess({});
    }, 3000);

    // Send email notification to client
    const emailBody = `
===========================================
         CONTRACT RENEWAL CONFIRMATION
===========================================

Dear ${selectedClient.contactPerson},

Your contract with ${selectedClient.company} has been successfully renewed!

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
                    RENEWAL DETAILS
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

• Renewal Period:      ${renewalForm.renewalPeriod} months
• New Start Date:      ${formatDate(today)}
• New End Date:        ${formatDate(newToDateStr)}
${renewalForm.newAmount ? `• New Contract Amount:  ${renewalForm.newAmount}` : ''}

${renewalForm.notes ? `
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
                 ADDITIONAL NOTES
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

${renewalForm.notes}
` : ''}

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
              NEXT STEPS
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

1. Please review the renewed contract terms
2. An updated agreement document will be shared shortly
3. Contact our support team for any questions

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

Thank you for your continued partnership!

Best Regards,
${selectedClient.owner}
Sales Team
${new Date().toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })}
`;

    simulateEmailSend(selectedClient.email, emailBody);
    
    alert(`✅ Contract renewed for ${selectedClient.company} until ${formatDate(newToDateStr)}\n📧 Renewal confirmation sent to ${selectedClient.email}`);
    setIsRenewalModalOpen(false);
  };

  const handleGeneratePO = (client) => {
    setSelectedClient(client);
    const poNumber = `PO-${client.clientNo}-${Date.now().toString().slice(-6)}`;
    setPoForm({
      poNumber: poNumber,
      poDate: new Date().toISOString().split('T')[0],
      amount: '',
      items: '',
      deliveryDate: new Date(new Date().setDate(new Date().getDate() + 30)).toISOString().split('T')[0],
      notes: ''
    });
    setIsGeneratePOModalOpen(true);
  };

  const submitPurchaseOrder = () => {
    if (!poForm.amount || !poForm.items) {
      alert('Please fill amount and items/services');
      return;
    }

    const poData = {
      poNumber: poForm.poNumber,
      poDate: poForm.poDate,
      client: selectedClient,
      amount: poForm.amount,
      items: poForm.items,
      deliveryDate: poForm.deliveryDate,
      notes: poForm.notes,
      status: 'Pending',
      generatedAt: new Date().toISOString()
    };

    const existingPOs = JSON.parse(localStorage.getItem('purchaseOrders') || '[]');
    existingPOs.push(poData);
    localStorage.setItem('purchaseOrders', JSON.stringify(existingPOs));

    // Update client with PO generated status
    const updatedClients = clients.map(c => {
      if (c.id === selectedClient.id) {
        return {
          ...c,
          poGenerated: true,
          lastPONumber: poForm.poNumber
        };
      }
      return c;
    });
    setClients(updatedClients);
    localStorage.setItem('clientsData', JSON.stringify(updatedClients));

    // Show success tick mark on the button
    setPoSuccess({ [selectedClient.id]: true });
    setTimeout(() => {
      setPoSuccess({});
    }, 3000);

    const emailBody = `
===========================================
           PURCHASE ORDER GENERATED
===========================================

Dear ${selectedClient.contactPerson},

A Purchase Order has been generated for ${selectedClient.company}.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
                  PO DETAILS
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

• PO Number:          ${poForm.poNumber}
• PO Date:            ${formatDate(poForm.poDate)}
• Amount:             ${poForm.amount}
• Items/Services:     ${poForm.items}
• Delivery Date:      ${formatDate(poForm.deliveryDate)}

${poForm.notes ? `
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
                 ADDITIONAL NOTES
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

${poForm.notes}
` : ''}

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
              NEXT STEPS
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

1. Please review the PO details
2. Confirm receipt of this Purchase Order
3. Arrange for delivery as per schedule

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

Best Regards,
${selectedClient.owner}
Sales Team
`;

    simulateEmailSend(selectedClient.email, emailBody);
    
    alert(`✅ Purchase Order ${poForm.poNumber} generated successfully!\n📧 PO sent to ${selectedClient.email}`);
    setIsGeneratePOModalOpen(false);
  };

  const simulateEmailSend = (to, body) => {
    // In production: integrate with EmailJS, SendGrid, or backend API
  };

  const formatDate = (dateString) => {
    if (!dateString) return '—';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  const isRenewalNeeded = (toDate) => {
    if (!toDate) return false;
    const today = new Date();
    const endDate = new Date(toDate);
    const daysRemaining = Math.ceil((endDate - today) / (1000 * 60 * 60 * 24));
    return daysRemaining <= 30 && daysRemaining > 0;
  };

  return (
    <div className="cv-container">
      <div className="cv-wrapper">
        <div className="cv-header">
          <div className="cv-header-top">
            <div className="cv-header-left">
              <h1 className="cv-title">Clients / Vendors</h1>
             
            </div>
            <button className="cv-add-btn" onClick={() => setIsAddClientModalOpen(true)}>
              + Add Client
            </button>
          </div>
          
        </div>

        {/* Clients Table - All Fields Visible */}
        <div className="cv-table-section">
          <div className="cv-table-responsive">
            <table className="cv-table">
              <thead>
                <tr>
                  <th>CLIENT #</th>
                  <th>COMPANY</th>
                  <th>CONTACT</th>
                  <th>EMAIL</th>
                  <th>PHONE</th>
                  <th>WEBSITE</th>
                  <th>AGREEMENT</th>
                  <th>VALID FROM</th>
                  <th>VALID TO</th>
                  <th>NEXT RENEWAL</th>
                  <th> STATUS</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              <tbody>
                {clients.map((client) => (
                  <tr key={client.id} className={isRenewalNeeded(client.toDate) ? 'cv-renewal-warning' : ''}>
                    <td className="cv-cell-client-no">{client.clientNo}</td>
                    <td className="cv-cell-company">{client.company}</td>
                    <td>{client.contactPerson}</td>
                    <td className="cv-cell-email">{client.email}</td>
                    <td>{client.phone}</td>
                    <td className="cv-cell-website">
                      {client.website ? (
                        <a href={client.website} target="_blank" rel="noopener noreferrer" className="cv-website-link">
                          🌐 Visit
                        </a>
                      ) : '—'}
                    </td>
                    <td className="cv-cell-agreement">
                      {client.agreementDoc ? (
                        <button className="cv-download-small-btn" onClick={() => alert(`Downloading ${client.agreementDoc}`)}>
                          📄 View
                        </button>
                      ) : '—'}
                    </td>
                    <td>{formatDate(client.fromDate)}</td>
                    <td className={isRenewalNeeded(client.toDate) ? 'cv-expiring-soon' : ''}>
                      {formatDate(client.toDate)}
                      {isRenewalNeeded(client.toDate) && <span className="cv-renewal-badge">⚠️</span>}
                    </td>
                    <td className="cv-renewal-cell">
                      {client.nextRenewalDate ? (
                        <button 
                          className={`cv-renewal-small-btn ${renewalSuccess[client.id] ? 'cv-renewal-success' : ''}`}
                          onClick={() => handleRenewal(client)}
                          title="Click to renew contract"
                        >
                          {renewalSuccess[client.id] ? '✅ Done!' : `🔄 Renew (${formatDate(client.nextRenewalDate)})`}
                        </button>
                      ) : '—'}
                    </td>
                    <td>
                      {client.status ? (
                        <span className="cv-po-success-badge">
                          ✅ {client.status}
                        </span>
                      ) : (
                        <span className="cv-po-pending-badge">Pending</span>
                      )}
                    </td>
                    <td>
                      <div className="cv-action-buttons">
                        <button className="cv-view-btn" onClick={() => viewClientDetails(client)}>
                          View
                        </button>
                        <button 
                          className={`cv-po-btn ${poSuccess[client.id] ? 'cv-po-success' : ''}`} 
                          onClick={() => handleGeneratePO(client)}
                          disabled={client.poGenerated}
                        >
                          {poSuccess[client.id] ? '✅ Sent!' : client.poGenerated ? '✓ PO Done' : '📄 Gen PO'}
                        </button>
                      </div>
                    </td>
                    </tr>
                
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Add Client Modal */}
      {isAddClientModalOpen && (
        <div className="cv-modal-overlay" onClick={() => setIsAddClientModalOpen(false)}>
          <div className="cv-modal cv-add-modal" onClick={(e) => e.stopPropagation()}>
            <div className="cv-modal-header">
              <h3>Add New Client</h3>
              <button className="cv-modal-close" onClick={() => setIsAddClientModalOpen(false)}>×</button>
            </div>
            <div className="cv-modal-body">
              <div className="cv-form-row">
                <div className="cv-form-group">
                  <label>Company <span className="cv-required">*</span></label>
                  <input type="text" name="company" value={formData.company} onChange={handleInputChange} placeholder="Enter company name" />
                </div>
                <div className="cv-form-group">
                  <label>Contact Person <span className="cv-required">*</span></label>
                  <input type="text" name="contactPerson" value={formData.contactPerson} onChange={handleInputChange} placeholder="Full name" />
                </div>
              </div>

              <div className="cv-form-row">
                <div className="cv-form-group">
                  <label>Email <span className="cv-required">*</span></label>
                  <input type="email" name="email" value={formData.email} onChange={handleInputChange} placeholder="email@company.com" />
                </div>
                <div className="cv-form-group">
                  <label>Phone <span className="cv-required">*</span></label>
                  <input type="tel" name="phone" value={formData.phone} onChange={handleInputChange} placeholder="+91 XXXXXXXXXX" />
                </div>
              </div>

              <div className="cv-form-row">
                <div className="cv-form-group">
                  <label>Valid From Date</label>
                  <input type="date" name="fromDate" value={formData.fromDate} onChange={handleInputChange} />
                </div>
                <div className="cv-form-group">
                  <label>Valid To Date</label>
                  <input type="date" name="toDate" value={formData.toDate} onChange={handleInputChange} />
                </div>
              </div>

              <div className="cv-form-row">
                <div className="cv-form-group">
                  <label>Website</label>
                  <input type="url" name="website" value={formData.website} onChange={handleInputChange} placeholder="https://company.com" />
                </div>
                <div className="cv-form-group">
                  <label>Linked Enquiry</label>
                  <input type="text" name="linkedEnquiry" value={formData.linkedEnquiry} onChange={handleInputChange} placeholder="e.g., ENQ-XXXXX" />
                </div>
              </div>

              <div className="cv-form-row">
                <div className="cv-form-group">
                  <label>Agreement Document</label>
                  <input type="file" name="agreementDoc" onChange={handleInputChange} accept=".pdf,.doc,.docx" />
                </div>
                <div className="cv-form-group">
                  <label>Owner <span className="cv-required">*</span></label>
                  <select name="owner" value={formData.owner} onChange={handleInputChange}>
                    {ownerOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                  </select>
                </div>
              </div>
            </div>
            <div className="cv-modal-footer">
              <button className="cv-cancel-button" onClick={() => setIsAddClientModalOpen(false)}>Cancel</button>
              <button className="cv-save-button" onClick={handleAddClient}>Save Client</button>
            </div>
          </div>
        </div>
      )}

      {/* View Client Modal */}
      {isViewClientModalOpen && selectedClient && (
        <div className="cv-modal-overlay" onClick={() => setIsViewClientModalOpen(false)}>
          <div className="cv-modal cv-details-modal" onClick={(e) => e.stopPropagation()}>
            <div className="cv-modal-header">
              <h3>Client Details - {selectedClient.clientNo}</h3>
              <button className="cv-modal-close" onClick={() => setIsViewClientModalOpen(false)}>×</button>
            </div>
            <div className="cv-modal-body">
              <div className="cv-details-grid">
                <div className="cv-detail-row"><span className="cv-detail-label">Client #:</span><span className="cv-detail-value">{selectedClient.clientNo}</span></div>
                <div className="cv-detail-row"><span className="cv-detail-label">Company:</span><span className="cv-detail-value">{selectedClient.company}</span></div>
                <div className="cv-detail-row"><span className="cv-detail-label">Contact Person:</span><span className="cv-detail-value">{selectedClient.contactPerson}</span></div>
                <div className="cv-detail-row"><span className="cv-detail-label">Email:</span><span className="cv-detail-value">{selectedClient.email}</span></div>
                <div className="cv-detail-row"><span className="cv-detail-label">Phone:</span><span className="cv-detail-value">{selectedClient.phone}</span></div>
                <div className="cv-detail-row"><span className="cv-detail-label">Linked Enquiry:</span><span className="cv-detail-value">{selectedClient.linkedEnquiry}</span></div>
                <div className="cv-detail-row"><span className="cv-detail-label">Website:</span><span className="cv-detail-value">{selectedClient.website ? <a href={selectedClient.website} target="_blank" rel="noopener noreferrer">{selectedClient.website}</a> : '—'}</span></div>
                <div className="cv-detail-row"><span className="cv-detail-label">Agreement:</span><span className="cv-detail-value">{selectedClient.agreementDoc ? <button className="cv-download-btn" onClick={() => alert(`Downloading ${selectedClient.agreementDoc}`)}>📄 Download</button> : '—'}</span></div>
                <div className="cv-detail-row"><span className="cv-detail-label">Valid From:</span><span className="cv-detail-value">{formatDate(selectedClient.fromDate)}</span></div>
                <div className="cv-detail-row"><span className="cv-detail-label">Valid To:</span><span className="cv-detail-value">{formatDate(selectedClient.toDate)}</span></div>
                <div className="cv-detail-row"><span className="cv-detail-label">Last Renewal:</span><span className="cv-detail-value">{selectedClient.lastRenewalDate ? formatDate(selectedClient.lastRenewalDate) : '—'}</span></div>
                <div className="cv-detail-row"><span className="cv-detail-label">Next Renewal:</span><span className="cv-detail-value">{selectedClient.nextRenewalDate ? formatDate(selectedClient.nextRenewalDate) : '—'}</span></div>
                <div className="cv-detail-row"><span className="cv-detail-label">Renewals Done:</span><span className="cv-detail-value">{selectedClient.renewalSentCount || 0}</span></div>
                <div className="cv-detail-row"><span className="cv-detail-label">PO Status:</span><span className="cv-detail-value">{selectedClient.poGenerated ? `✅ ${selectedClient.lastPONumber}` : 'Pending'}</span></div>
                <div className="cv-detail-row"><span className="cv-detail-label">Owner:</span><span className="cv-detail-value">{selectedClient.owner}</span></div>
                <div className="cv-detail-row"><span className="cv-detail-label">Onboarded:</span><span className="cv-detail-value">{formatDate(selectedClient.onboarded)}</span></div>
                <div className="cv-detail-row"><span className="cv-detail-label">Source:</span><span className="cv-detail-value">{selectedClient.source}</span></div>
                <div className="cv-detail-row"><span className="cv-detail-label">Status:</span><span className={`cv-status-badge ${selectedClient.status === 'Active' ? 'cv-status-active' : 'cv-status-inactive'}`}>{selectedClient.status}</span></div>
              </div>
            </div>
            <div className="cv-modal-footer">
              <button className="cv-renewal-modal-btn" onClick={() => { setIsViewClientModalOpen(false); handleRenewal(selectedClient); }}>🔄 Renew Contract</button>
              <button className="cv-po-modal-btn" onClick={() => { setIsViewClientModalOpen(false); handleGeneratePO(selectedClient); }} disabled={selectedClient.poGenerated}>📄 Generate PO</button>
              <button className="cv-cancel-button" onClick={() => setIsViewClientModalOpen(false)}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* Renewal Modal */}
      {isRenewalModalOpen && selectedClient && (
        <div className="cv-modal-overlay" onClick={() => setIsRenewalModalOpen(false)}>
          <div className="cv-modal cv-renewal-modal" onClick={(e) => e.stopPropagation()}>
            <div className="cv-modal-header">
              <h3>🔄 Renew Contract - {selectedClient.company}</h3>
              <button className="cv-modal-close" onClick={() => setIsRenewalModalOpen(false)}>×</button>
            </div>
            <div className="cv-modal-body">
              <div className="cv-info-box">
                <p><strong>📧 Client Email:</strong> {selectedClient.email}</p>
                <p><strong>📅 Current Valid Till:</strong> {formatDate(selectedClient.toDate)}</p>
                <p><strong>👤 Contact Person:</strong> {selectedClient.contactPerson}</p>
                <p><strong>🔄 Renewals Done:</strong> {selectedClient.renewalSentCount || 0}</p>
              </div>

              <div className="cv-form-group">
                <label>Renewal Period (months)</label>
                <select value={renewalForm.renewalPeriod} onChange={(e) => setRenewalForm({...renewalForm, renewalPeriod: parseInt(e.target.value)})}>
                  <option value="3">3 Months</option>
                  <option value="6">6 Months</option>
                  <option value="12">12 Months (1 Year)</option>
                  <option value="24">24 Months (2 Years)</option>
                  <option value="36">36 Months (3 Years)</option>
                </select>
              </div>

              <div className="cv-form-group">
                <label>New Contract Amount (if changed)</label>
                <input type="text" placeholder="₹0.00" value={renewalForm.newAmount} onChange={(e) => setRenewalForm({...renewalForm, newAmount: e.target.value})} />
              </div>

              <div className="cv-form-group">
                <label>Additional Notes / Terms</label>
                <textarea rows="3" placeholder="Any special terms or conditions for renewal..." value={renewalForm.notes} onChange={(e) => setRenewalForm({...renewalForm, notes: e.target.value})} />
              </div>

              <div className="cv-warning-box">
                <p>📧 <strong>Email Notification:</strong> A renewal confirmation email with all details will be sent to <strong>{selectedClient.email}</strong> upon submission.</p>
              </div>
            </div>
            <div className="cv-modal-footer">
              <button className="cv-cancel-button" onClick={() => setIsRenewalModalOpen(false)}>Cancel</button>
              <button className="cv-renewal-submit-btn" onClick={submitRenewal}>
                ✅ Confirm Renewal & Send Email
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Generate Purchase Order Modal */}
      {isGeneratePOModalOpen && selectedClient && (
        <div className="cv-modal-overlay" onClick={() => setIsGeneratePOModalOpen(false)}>
          <div className="cv-modal cv-po-modal" onClick={(e) => e.stopPropagation()}>
            <div className="cv-modal-header">
              <h3>📄 Generate Purchase Order - {selectedClient.company}</h3>
              <button className="cv-modal-close" onClick={() => setIsGeneratePOModalOpen(false)}>×</button>
            </div>
            <div className="cv-modal-body">
              <div className="cv-info-box">
                <p><strong>Client:</strong> {selectedClient.company}</p>
                <p><strong>Email:</strong> {selectedClient.email}</p>
              </div>

              <div className="cv-form-row">
                <div className="cv-form-group">
                  <label>PO Number</label>
                  <input type="text" value={poForm.poNumber} readOnly className="cv-readonly-field" />
                </div>
                <div className="cv-form-group">
                  <label>PO Date</label>
                  <input type="date" value={poForm.poDate} onChange={(e) => setPoForm({...poForm, poDate: e.target.value})} />
                </div>
              </div>

              <div className="cv-form-group">
                <label>Items/Services <span className="cv-required">*</span></label>
                <textarea rows="3" placeholder="Describe items or services..." value={poForm.items} onChange={(e) => setPoForm({...poForm, items: e.target.value})} />
              </div>

              <div className="cv-form-row">
                <div className="cv-form-group">
                  <label>Amount <span className="cv-required">*</span></label>
                  <input type="text" placeholder="₹0.00" value={poForm.amount} onChange={(e) => setPoForm({...poForm, amount: e.target.value})} />
                </div>
                <div className="cv-form-group">
                  <label>Expected Delivery Date</label>
                  <input type="date" value={poForm.deliveryDate} onChange={(e) => setPoForm({...poForm, deliveryDate: e.target.value})} />
                </div>
              </div>

              <div className="cv-form-group">
                <label>Additional Notes</label>
                <textarea rows="2" placeholder="Special instructions or terms..." value={poForm.notes} onChange={(e) => setPoForm({...poForm, notes: e.target.value})} />
              </div>

              <div className="cv-warning-box">
                <p>📧 The Purchase Order will be sent to <strong>{selectedClient.email}</strong> upon generation.</p>
              </div>
            </div>
            <div className="cv-modal-footer">
              <button className="cv-cancel-button" onClick={() => setIsGeneratePOModalOpen(false)}>Cancel</button>
              <button className="cv-po-submit-btn" onClick={submitPurchaseOrder}>Generate PO</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientsVendors;

